module.exports = __webpack_public_path__ + "assets/img/zhijiaob_3013.f98fb10a.jpg";